import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c8d8cdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-no-template" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Section: "),
  /*#__PURE__*/_createElementVNode("b", null, "Disease Awareness")
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Endpoint: ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode("No Template found for the slide."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please check LYRA or Development Team.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _hoisted_3,
      _createElementVNode("b", null, _toDisplayString(_ctx.endpointId), 1)
    ]),
    _hoisted_4
  ]))
}